import {Star,Trophy,Crown,BarChart3,LetterText,Grid2X2} from 'lucide-react';
import React from 'react';
import './DailyBadges.css';
const {ACHIEVEMENTS}=require('../utils/achievements');
const {DAILY_BADGES,badgeByName}=require('../utils/dailyBadges');
export default function DailyBadgeArt({id,name,className=''}){
 const badge=DAILY_BADGES.find(b=>b.id===id)||badgeByName(name);
 if(!badge){const legacy=ACHIEVEMENTS.find(b=>b.id===id||b.title===name);if(!legacy)return null;
 const icons={'regular-player':Star,'win-streak':Trophy,'master-player':Crown,'big-score':BarChart3,'board-master':Grid2X2};const Icon=icons[legacy.id]||LetterText;
 return <span className={`legacy-medal-r9 medal-${legacy.id} ${className}`} role="img" aria-label={legacy.title}><span><Icon aria-hidden="true"/>{legacy.recordSize&&<b className="medal-size-r10">{legacy.recordSize}</b>}</span></span>;}
 return <span className={`daily-badge-art ${className}`} style={{backgroundPosition:`${badge.art%3*50}% ${Math.floor(badge.art/3)*100}%`}} role="img" aria-label={badge.name}/>;
}
